module.exports = __webpack_public_path__ + "static/media/mapp-review-active-star.c480cea0.svg";